var bundleAPI;
var originalMiniCssF = __webpack_require__.miniCssF;
__webpack_require__.miniCssF = function(chunkId) {
  if (!bundleAPI) {
    bundleAPI = window.kolibriCoreAppGlobal["kolibri/rtlcss"].rtlManager.registerBundle("kolibri.plugins.learn.app");
  }
  return bundleAPI.miniCssF(originalMiniCssF(chunkId));
};